import { DialogType } from '@gasbi/shared/web/components/Dialog/types';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { GasConsumingEquipmentForm } from '@/forms/GasConsumingEquipmentForm';

const GasConsumingEquipmentDetailsModal = () => {
  const navigate = useNavigate();
  const { meteringNodeId } = useOutletContext<{ meteringNodeId: string }>();
  if (!meteringNodeId) {
    return null;
  }
  return (
    <GasConsumingEquipmentForm
      type={DialogType.Preview}
      isModalOpen
      onDialogClose={() => navigate('..')}
      meteringNodeId={meteringNodeId}
    />
  );
};

export default GasConsumingEquipmentDetailsModal;
